// removed by extract-text-webpack-plugin
module.exports = {"vpPostRecordingActionsSection":"vpPostRecordingActionsSection___3JPum","vpPostRecordingActionButton":"vpPostRecordingActionButton___1EHFd"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CampaignLanding/PostRecordingActions.module.less
// module id = 3484
// module chunks = 33